import React from "react";
import { Modal, Card, Row, Col } from "react-bootstrap";

interface RoomSelectionModalProps {
  show: boolean;
  onClose: () => void;
  onRoomSelect: (roomKey: string) => void;
}

const RoomSelectionModal: React.FC<RoomSelectionModalProps> = ({
  show,
  onClose,
  onRoomSelect,
}) => {
  const demoImage =
    "https://i.pinimg.com/736x/93/30/05/933005a18a0d34d9c16549f37d714724.jpg";

  const rooms = ["1", "2", "3", "4", "5", "6", "7", "8"];

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="room-selection-modal"
      contentClassName="border-0 rounded-4 shadow"
      backdropClassName="bg-dark bg-opacity-50"
    >
      <Modal.Body className="bg-white px-5 py-4">
        <h4 className="text-center fw-bold mb-4">Select a Room</h4>
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
          {rooms.map((roomKey) => (
            <Col key={roomKey}>
              <Card
                className="border-0 rounded shadow-sm room-card h-100"
                onClick={() => {
                  onClose();
                  onRoomSelect(roomKey);
                }}
                role="button"
              >
                <div className="position-relative overflow-hidden rounded-top">
                  <Card.Img
                    variant="top"
                    src={demoImage}
                    alt={`Room ${roomKey}`}
                    className="room-img"
                  />
                </div>
                <Card.Body className="text-center py-3">
                  <Card.Title className="mb-0 fw-semibold fs-5 text-nowrap">
                    Room {roomKey}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default RoomSelectionModal;
